import { useNavigate } from '@tanstack/react-router';

import { openExternalUrl } from '@/utils/open-external-url';

const bookingRoutes = [
  { action: 'schedule', to: '/participants/projects/$projectId/schedule' },
  { action: 'reschedule', to: '/participants/projects/$projectId/reschedule' },
  {
    action: 'cancel-booking',
    to: '/participants/projects/$projectId/cancel-booking',
  },
] as const;

export function useBookingNavigation(projectId: string) {
  const navigate = useNavigate();

  return (url?: string | null) => {
    if (!url) return;
    const target = new URL(url, globalThis.location.origin);
    const route =
      target.origin === globalThis.location.origin
        ? bookingRoutes.find(
            ({ action }) =>
              target.pathname ===
              `/next/participants/projects/${encodeURIComponent(projectId)}/${action}`,
          )
        : undefined;

    if (route) {
      void navigate({ to: route.to, params: { projectId } });
    } else {
      openExternalUrl(url);
    }
  };
}
